import { Flex } from '@grupoboticario/flora-react';
import { CalendarCheckIcon } from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components';
import { useLoyaltyIncentiveCampaign } from 'pages/IncentiveCampaign/hooks';

import Styles from './OptInClosed.styles';

export const OptInClosed = () => {
  const { optInData } = useLoyaltyIncentiveCampaign();
  const memberData = optInData?.campaign ?? null;

  return (
    <Flex direction='column' gap='$4'>
      <Styles.CardInfo>
        <Flex direction='column' gap='$2'>
          <Flex gap='$2'>
            <CalendarCheckIcon size={28} color='$nonInteractivePredominant' />
            <ResponsiveFloraTypography
              color='$nonInteractivePredominant'
              fontSize='subtitle'
              fontWeight='bold'
            >
              Campanha encerrada!
            </ResponsiveFloraTypography>
          </Flex>
          {memberData !== null ? (
            <ResponsiveFloraTypography
              color='$nonInteractivePredominant'
              fontSize='subtitle'
              fontWeight='bold'
            >
              Estamos apurando o resultado da campanha e logo estará disponível!
            </ResponsiveFloraTypography>
          ) : (
            <ResponsiveFloraTypography
              color='$nonInteractivePredominant'
              fontSize='bodyLargeStandard'
              fontWeight='bold'
            >
              O período para inscrição na campanha encerrou. Fique de olho nos nossos canais
              digitais e não perca as próximas campanhas!
            </ResponsiveFloraTypography>
          )}
        </Flex>
      </Styles.CardInfo>
    </Flex>
  );
};
